import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService, NzModalService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {PermissionComparisonComponent} from "../components/permission-comparison/permission-comparison.component";
import {Observable} from "rxjs/Observable";
import {GlobalService} from "../services/global.service";

@Injectable()
export class CheckMonitorGuard implements CanActivate {
  userType: string;

  constructor(private msg: NzMessageService,
              public http: HttpCommonService,
              private globalService: GlobalService,
              private showAlert: NzModalService) {
    this.userType = this.globalService.getUserInfo("_userType");
  }

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let companyId = routerInfo.queryParams['companyId'];
    let request0 = this.http.get("/enterprise/detail/xhsRest/supervise/hasSupervise", {companyId: companyId});
    let request1 = this.http.get("/enterprise/detail/xhsRest/supervise/getSuperviseAmount");
    let request2 = this.http.get("/user/center/xhsRest/hasPermission", {permissionId: "company:checkSupervise"});
    return Observable.forkJoin([request0, request1, request2]).map((result: any) => {
      let hasSupervise = result[0].data;//0已监测 -1未监测
      let superviseAmount = result[1].data;
      let isVip = result[2].data > 0;

      if (hasSupervise == '-1') {
        if (this.userType == 'enterprise' && ((isVip && superviseAmount < 2000) || superviseAmount < 10)) {
          this.showAlert.confirm({
            title: '',
            content: '该企业不在您的监测企业列表中，不能查看历史监测信息，请添加监测后再查看',
            onOk() {
            },
            onCancel() {
            }
          });
        } else {
          this.showAlert.open({
            content: PermissionComparisonComponent,
            componentParams: {companyId: companyId},
            width: 650,
            onCancel() {
            },
            onOk() {
            },
            footer: false
          });
        }
        return false;
      } else {
        return true;
      }
    }).first();

  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/checkMonitorGuard.ts